import $ from "jquery";
// describe and create object
class Copyclip {
  constructor() {
    this.copy_icon = $(".social .copy");
    this.events();
  }

  // events for triggering function
  events() {
    this.copy_icon.on("click", this.print_to_clipboard);
  }

  // method/function

  print_to_clipboard() {
    var permlink = $(location).attr("href");
    navigator.clipboard.writeText(permlink);
    event.preventDefault();
  }
}

export default Copyclip;
